import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  orderBillingAddressById,
  orderShippingAddressById,
} from '/redux/selector/client.selector';

import AddressesSection from './AddressesSection';

export default connect(
  createStructuredSelector({
    billingAddress: orderBillingAddressById,
    shippingAddress: orderShippingAddressById,
  }),
)(AddressesSection);
